import {
  QuestionTemplateSendAttributes,
  QuestionTemplateModel,
} from 'src/models/QuestionTemplateModel';
import { Notify } from 'quasar';
import { QuestionTemplateAdapterInteface } from 'src/adapter/QuestionTemplateAdapterInterface';
import { apiErrorHandler } from 'src/error/handler/apiErrorHandler';
export class QuestionTemplateApiClass {
  adapter: QuestionTemplateAdapterInteface;
  constructor(adapter: QuestionTemplateAdapterInteface) {
    this.adapter = adapter;
  }
  async createQuestionTemplate(
    attributes: QuestionTemplateSendAttributes
  ): Promise<QuestionTemplateModel> {
    try {
      const questionTemplate = await this.adapter.createQuestionTemplate(
        attributes
      );
      Notify.create({
        type: 'positive',
        message: '作成しました',
      });
      return new QuestionTemplateModel(questionTemplate);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async updateQuestionTemplate(
    id: string,
    attributes: QuestionTemplateSendAttributes
  ): Promise<QuestionTemplateModel> {
    try {
      const QuestionTemplate = await this.adapter.updateQuestionTemplate(
        id,
        attributes
      );
      Notify.create({
        type: 'positive',
        message: '更新しました',
      });
      return new QuestionTemplateModel(QuestionTemplate);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async deleteQuestionTemplate(id: string): Promise<boolean> {
    try {
      const res = await this.adapter.deleteQuestionTemplate(id);
      Notify.create({
        type: 'positive',
        message: '削除しました',
      });
      return res;
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
}
